"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var helpers_1 = require("../../helpers");
var env_1 = require("../../helpers/env");
var search_1 = require("../../pages/explore/search");
require("../../pages/global.css");
var index_1 = require("../profile/index");
// tslint:disable-next-line:no-var-requires
var styles = require('./header.css');
var UserMenu = /** @class */ (function (_super) {
    __extends(UserMenu, _super);
    function UserMenu() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UserMenu.prototype.componentWillMount = function () {
        this.setState({ open: false });
        this.open = this.open.bind(this);
        this.close = this.close.bind(this);
    };
    UserMenu.prototype.close = function () {
        this.setState({ open: false });
    };
    UserMenu.prototype.open = function () {
        this.setState({ open: !this.state.open });
    };
    UserMenu.prototype.render = function () {
        return (React.createElement("div", { onClick: this.open, onMouseLeave: this.close, className: this.state.open ? styles.show : '' },
            React.createElement("img", { src: env_1.env().staticSrcPath() + '/assets/images/icons/arrow-down.svg' }),
            React.createElement("div", { className: styles.menu },
                React.createElement("a", { href: "/profile/" + this.props.handle }, "Profile"),
                React.createElement("a", { href: '/settings' }, "Settings"),
                React.createElement("a", { href: '/settings/pro' }, "PRO Account"),
                React.createElement("a", { href: '/logout' }, "Logout"))));
    };
    return UserMenu;
}(React.Component));
exports.UserMenu = UserMenu;
var Search = /** @class */ (function (_super) {
    __extends(Search, _super);
    function Search(props) {
        var _this = _super.call(this, props) || this;
        _this.submitSearch = _this.submitSearch.bind(_this);
        _this.inputText = _this.inputText.bind(_this);
        _this.clearInput = _this.clearInput.bind(_this);
        _this.showMobileInput = _this.showMobileInput.bind(_this);
        _this.hideOnMobile = _this.hideOnMobile.bind(_this);
        _this.exploreInput = React.createRef();
        return _this;
    }
    Search.prototype.componentWillMount = function () {
        this.clearInput();
        this.setState({ showMobileInput: false });
    };
    Search.prototype.componentDidMount = function () {
        this.clearInput();
    };
    Search.prototype.componentDidUpdate = function () {
        if (this.state.showMobileInput && this.exploreInput.current) {
            this.exploreInput.current.focus();
        }
    };
    Search.prototype.showMobileInput = function () {
        this.setState({ showMobileInput: true });
        if (this.exploreInput.current) {
            this.exploreInput.current.focus();
        }
    };
    Search.prototype.hideOnMobile = function () {
        this.setState({ showMobileInput: false });
        if (this.exploreInput.current) {
            this.exploreInput.current.blur();
        }
    };
    Search.prototype.clearInput = function () {
        this.setState({ searchText: '' });
    };
    Search.prototype.inputText = function (e) {
        var cleanText = helpers_1.escapeHtml(e.currentTarget.value);
        this.setState({ searchText: cleanText });
    };
    Search.prototype.submitSearch = function (e) {
        e.preventDefault();
        if (!this.props.isExplorePage) {
            window.location.href = '/explore?q=' + encodeURI(this.state.searchText);
            return;
        }
        if (this.exploreInput.current) {
            this.exploreInput.current.blur();
        }
        this.props.getSearch(this.state.searchText, true);
        this.clearInput();
    };
    Search.prototype.render = function () {
        return (React.createElement("div", { className: styles.explore + (this.state.showMobileInput ? ' ' + styles.showMobileInput : '') },
            React.createElement("form", null,
                React.createElement("input", { type: 'text', ref: this.exploreInput, onChange: this.inputText, value: this.state.searchText, placeholder: 'explore', onFocus: this.clearInput, onBlur: this.hideOnMobile, autoComplete: 'off' }),
                React.createElement("button", { onClick: this.submitSearch },
                    React.createElement("img", { src: env_1.env().staticSrcPath() + '/assets/images/icons/search.svg' }))),
            React.createElement("img", { src: env_1.env().staticSrcPath() + '/assets/images/icons/search.svg', className: styles.mobileInputToggler, onClick: this.showMobileInput })));
    };
    return Search;
}(React.Component));
exports.HeaderComponent = function (_a) {
    var user = _a.user, loginUrl = _a.loginUrl, isExplorePage = _a.isExplorePage, getSearch = _a.getSearch;
    return (React.createElement("div", { className: styles.header },
        React.createElement("div", { className: styles.holder },
            React.createElement("div", { className: styles.sectionHolder },
                React.createElement("a", { href: '/' },
                    React.createElement("img", { className: styles.logo, src: env_1.env().staticSrcPath() + '/assets/images/logos/ayvri-logo-color.svg' })),
                React.createElement(Search, { isExplorePage: isExplorePage, getSearch: getSearch }),
                React.createElement("a", { href: '/upload', className: styles.create },
                    "Create Your Own",
                    React.createElement("img", { src: env_1.env().staticSrcPath() + '/assets/images/icons/upload_arrow_color.svg' }))),
            React.createElement("div", { className: styles.sectionHolder + ' ' + styles.signinHolder }, user.handle ? (React.createElement("div", { className: styles.profileControls },
                React.createElement("a", { href: '/profile/' + user.handle }, index_1.smallProfile(user, styles.profile)),
                React.createElement(UserMenu, { handle: user.handle }))) : (React.createElement("a", { className: styles.signin, href: loginUrl.loginUrl },
                "Sign In",
                React.createElement("img", { src: env_1.env().staticSrcPath() + '/assets/images/icons/button-actor.svg' })))))));
};
function mapStateToProps(state) {
    return {
        user: state.user,
        loginUrl: state.loginUrl,
        isExplorePage: !!state.search,
    };
}
exports.mapStateToProps = mapStateToProps;
function mapDispatchToProps(dispatch) {
    return {
        getSearch: function (text, isNewSearch) { return dispatch(search_1.getSearch(search_1.buildQuery(text, { exact: false }), isNewSearch)); },
    };
}
exports.mapDispatchToProps = mapDispatchToProps;
exports.Header = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(exports.HeaderComponent);
